﻿import $ from 'jquery/dist/jquery';

window.$ = $;
window.jQuery = $;